// Generated types for NumericAttribute
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NumericShape } from '../enums';

import { AttributeReadAPI, AttributeWriteAPI } from './attribute';
import { AttributeReadAPISchemaObject, AttributeWriteAPISchemaObject } from './attribute';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface NumericAttributeReadAPI extends AttributeReadAPI {
  /** Value structure. SCALAR=single number, RANGE=[min, max], VECTOR=list of numbers (all sharing the canonical_unit). */
  shape?: NumericShape;
  /** If True, values must be integers — for counts (number of poles, mounting holes, gear teeth) and discrete classes (12/24/48 V class). Default False; most physical quantities are real-valued. */
  is_integer?: boolean;
  /** Lower plausibility bound (sanity check, not a hard constraint). Drives PROPERTY_VALUE_OUT_OF_PLAUSIBLE_RANGE completeness rule. */
  min_plausible?: number | null;
  /** Upper plausibility bound (sanity check). */
  max_plausible?: number | null;
}

export interface NumericAttributeWriteAPI extends AttributeWriteAPI {
  /** Value structure. SCALAR=single number, RANGE=[min, max], VECTOR=list of numbers (all sharing the canonical_unit). */
  shape?: NumericShape;
  /** If True, values must be integers — for counts (number of poles, mounting holes, gear teeth) and discrete classes (12/24/48 V class). Default False; most physical quantities are real-valued. */
  is_integer?: boolean;
  /** Lower plausibility bound (sanity check, not a hard constraint). Drives PROPERTY_VALUE_OUT_OF_PLAUSIBLE_RANGE completeness rule. */
  min_plausible?: number | null;
  /** Upper plausibility bound (sanity check). */
  max_plausible?: number | null;
  /** The SI unit values are stored in (e.g. 'Nm', 'rad/s', 'kg'). */
  canonical_unit?: string;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const NumericAttributeReadAPISchema: z.ZodType<NumericAttributeReadAPI> = AttributeReadAPISchemaObject.extend({
  shape: z.nativeEnum(NumericShape).optional(),
  is_integer: z.boolean().optional(),
  min_plausible: z.number().nullable().optional(),
  max_plausible: z.number().nullable().optional(),
}).passthrough();

export const NumericAttributeWriteAPISchema: z.ZodType<NumericAttributeWriteAPI> = AttributeWriteAPISchemaObject.extend({
  shape: z.nativeEnum(NumericShape).optional(),
  is_integer: z.boolean().optional(),
  min_plausible: z.number().nullable().optional(),
  max_plausible: z.number().nullable().optional(),
  canonical_unit: z.string().optional(),
}).passthrough();
